import { mulN } from "./muln";
export const neg = (out, v) => mulN(out, v, -1);
